import { useState, useEffect } from "react";
import { motion } from "framer-motion";

const Typewriter = ({ text, className }) => {
  const [displayedText, setDisplayedText] = useState("");
  const [i, setI] = useState(0);

  useEffect(() => {
    if (i < text.length) {
      const timeout = setTimeout(() => {
        setDisplayedText((prev) => prev + text.charAt(i));
        setI(i + 1);
      }, 100);
      return () => clearTimeout(timeout);
    }
  }, [i, text]);

  return <motion.span className={className}>{displayedText}</motion.span>;
};

export default Typewriter;